import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Error404Page from './pages/Error404Page';
import WeatherForecastPage from './pages/WeatherForecastPage';
import RolePage from './pages/Mantenedores/RolePage';
import UserPage from './pages/Mantenedores/UserPage';
import Home from './pages/HomePage';
import HomeV2 from './pagesV2/HomePageV2';
import Cookies from 'universal-cookie'
import CustomersPage from './pages/CustomersPage';
import ContractPage from './pages/ContractsPage';
import ContractPageV2 from './pagesV2/ContractsPageV2';
import CustomersPageCV from './pages/CustomersPageCV';
import CausasPage from './pages/CausasPage';
import LineaNegocio from './pages/LineaNegocioPage';
import Codigo from './pages/codigo';
import ServicesPage from './pages/Mantenedores/ServicesPage';
import GeneradorPage from './pages/GeneradorPage'
import LineBusinessPage from './pages/Mantenedores/LineBusinessPage'
import LayoutPage from './pages/Mantenedores/LayoutPage'
import MontosPage from './pages/Mantenedores/MontosPage'
import RegistroPage from './pages/RegistroPage';
import ContractDetailPage from './pages/ContractDetailPage';
import PerfilPage from './pages/PerfilPage';
import MisContratoPage from './pages/MisContratoPage';
//import CuotasPages from './pages/contrato/CuotasPages';
//import CuotasPage from './pages/CuotasPage';

import CuotasPage from './pages/CuotasPage';
import TabularPageV2 from './pages/TabularPageV2';
import DesbloqueoPage from './pages/DesbloqueoPage';
import HojaAtencion from './componentsV2/HojaAtencion';
import Defendido from './componentsV2/Defendido';
import Servicios from './componentsV2/Servicios';
import ContratoPage from './pagesV2/ContratoPage';
import Cuotas from './componentsV2/Cuotas';
import Causas from './componentsV2/Causas';

const getProfileFromCookies = () => {
    const cookies = new Cookies();
    const userRolId = parseInt(cookies.get('rolId'));
    return userRolId;
};


const ProtectedRoute = ({ children, allowedProfiles }) => {
    const userProfile = getProfileFromCookies();

    if (!allowedProfiles.includes(userProfile)) {
        // Redirigir a una página de error o a la página principal
        return <Navigate to="/*" replace />;
    }

    return children;
};

const App = () => {

    return (
        <>
            <Routes>
                {/*<Route path='/gestion_ventas/deudas' element={<GestionVentas type={'deudas'} />} />
                <Route path='/gestion_ventas/familia' element={<GestionVentas type={'familia'} />} />*/}
                <Route path='/MisContratoPage' element={<MisContratoPage />} />
                <Route path='/PerfilPage' element={<PerfilPage />} />
                <Route path='/RegistroPage' element={<RegistroPage />} />
                <Route path='/GeneradorPage' element={<GeneradorPage />} />
                <Route path='/CuotasPage' element={<CuotasPage />} />
                <Route path='/ServicesPage' element={<ServicesPage />} />
                <Route path='/LineBusinessPage' element={<LineBusinessPage />} />
                <Route path='/LayoutPage' element={<LayoutPage />} />
                <Route path='/MontosPage' element={<MontosPage />} />
                <Route path='/Codigo' element={<Codigo />} />
                <Route path='/LineaNegocio' element={<LineaNegocio />} />
                <Route path='/RoleList' element={<RolePage />} />
                <Route path='/UserPage' element={<UserPage />} />
                <Route path='/CustomersPage' element={<CustomersPage />} />
                <Route path='/ContractPage' element={<ContractPage />} />
                <Route path='/ContractDetailPage' element={<ContractDetailPage />} />
                <Route path='/CustomersPageCV' element={<CustomersPageCV />} />
                <Route path='/CausasPage' element={<CausasPage />} />
                <Route path='/DesbloqueoPage' element={<ProtectedRoute allowedProfiles={[1023, 1]}><DesbloqueoPage /></ProtectedRoute>} />
                <Route path='/TabularPageV2' element={<TabularPageV2 />} />
                <Route path='/weather-forecast' element={<WeatherForecastPage />} />
                <Route path='*' element={<Error404Page />} />

                <Route path="/ContratoPage" element={<ContratoPage />} />


                {/*<Route path='/Home' element={<Home />} />*/}
                <Route path='/Home' element={<HomeV2 />} />

                <Route path='/ContractPageV2' element={<ContractPageV2 />} />


                <Route path='/hojaAtencion' element={<HojaAtencion />} />
                <Route path='/Defendido' element={<Defendido />} />
                <Route path='/Servicios' element={<Servicios />} />
                <Route path='/Cuotas' element={<Cuotas />} />
                <Route path='/Causas' element={<Causas />} />


            </Routes>
        </>
    );
};

export default App;
